import React, {useContext, useMemo} from 'react';

import {lotContext} from "../../auction-lots-listing/components/lots-list-item/lots-list-item";
import {LotsContext} from "../../auction-lots-listing/auction-lots-listing";

const LotStatusBlock = () => {

    const {lotData} = useContext(lotContext);
    const {phrases: {ak_au_lot_nofix_expired, ak_au_lot_fix_expired, ak_au_copy_will_be_deleted}} = useContext(LotsContext);
    const {expired_flag, status, copy} = lotData;


    const phrase = useMemo(() => {
        let phrase = null;

        if (status === 'finalized') {
            phrase = ak_au_lot_fix_expired
        }
        if (status === 'nosale' && expired_flag) {
            phrase = ak_au_lot_nofix_expired
        }
        if (status === 'nosale' && copy === 1) {
            phrase = <span className="badge text-bg-danger"> {ak_au_copy_will_be_deleted}</span>
        }
        return phrase

    }, [status])

    if (phrase !== null) {
        return (
            <div className='d-flex flex-wrap justify-content-center text-muted align-items-sm-center'>
                {phrase}
            </div>
        );
    }

    return null;

}
export default LotStatusBlock